import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { IApplication, IApplicationInput, IProgramCycle } from '@ebb-v2/ebb-integration';
import { DocumentNode } from '@apollo/client/core';


@Injectable({
  providedIn: 'root'
})
export abstract class ApplicationApiService {

  abstract getApplicationList(): Observable<IApplication[]>;

  abstract getApplicationListByType(type: DocumentNode): Observable<IApplication[]>;

  abstract getApplication(id: string): Observable<IApplication|string>;

  abstract updateApplication(applicationInput: IApplicationInput, id: string): Observable<any>;

  abstract removeApplication(application: IApplication): Observable<IApplication>;

  abstract getProgramCycles(): Observable<IProgramCycle[]>;
}
